<ng-container [ngSwitch]="cardConfig.cardStyle">
  <ng-container *ngSwitchCase="'large'">
    <ng-container *ngTemplateOutlet="imageTop"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'small'">
    <ng-container *ngTemplateOutlet="imageRight"></ng-container>
  </ng-container>
</ng-container>

<ng-template #imageTop>
  <div
    class="action-card action-card--image-top flex-column space-between"
    [ngClass]="{
      'action-card--has-image': cardConfig.image,
      shadow: cardConfig.shadow,
      'mb-sm': cardConfig.marginBottom === 'small',
      'mb-md': cardConfig.marginBottom === 'medium',
      'mb-lg': !cardConfig.marginBottom || cardConfig.marginBottom === 'large',
    }"
  >
    <div class="action-card__hero flex-column" [style.background-image]="'url(' + cardConfig.image + ')'"></div>
    <div class="flex-column action-card__content">
      <ng-container *ngIf="cardConfig.label">
        <ng-container *ngTemplateOutlet="label"></ng-container>
      </ng-container>
      <typography-legacy *ngIf="cardConfig.title" text-medium-semibold class="mb-sm">{{ cardConfig.title | translate }}</typography-legacy>
      <typography-legacy text-xsmall-regular class="action-card__body">{{ cardConfig.body | translate }}</typography-legacy>
      <div class="flex-row space-between action-card_footer_action mt-sm">
        <div class="flex-column">
          <bw-icon-legacy *ngIf="cardConfig.optionalIcon" [iconName]="cardConfig.optionalIcon" [size]="16"></bw-icon-legacy>
        </div>
        <div class="flex-column">
          <div tabindex="1" class="action-card__cta_icon" (click)="emitCtaClicked()" (keyup.enter)="emitCtaClicked()">
            {{ cardConfig.ctaString }}
            <bw-icon-legacy [iconName]="'chevron_right'" [color]="'var(--blue-50)'" [size]="18"></bw-icon-legacy>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #imageRight>
  <div
    class="action-card action-card--image-right flex-row space-between"
    [ngClass]="{
      'action-card--has-image': cardConfig.image && !cardConfig.ctaString,
      'no-min-height': cardConfig.removeMinHeight,
      'no-max-width': cardConfig.removeMaxWidth,
      'mb-sm': cardConfig.marginBottom === 'small',
      'mb-md': cardConfig.marginBottom === 'medium',
      'mb-lg': cardConfig.marginBottom === 'large',
      shadow: cardConfig.shadow,
      'no-click': cardConfig.hideCta || cardConfig.ctaString
    }"
    [style.background-color]="cardConfig.bgColor || 'unset'"
    [attr.tabindex]="cardConfig.ctaString ? null : 1"
    (click)="!cardConfig.ctaString && emitCtaClicked()"
    (keyup.enter)="!cardConfig.ctaString && emitCtaClicked()"
  >
    <div class="flex-column action-card__content" [ngClass]="{ 'action-card__content--with-cta': cardConfig.ctaString }">
      <ng-container *ngIf="cardConfig.label">
        <ng-container *ngTemplateOutlet="label"></ng-container>
      </ng-container>
      <typography-legacy text-medium-semibold class="mb-sm">{{ cardConfig.title | translate }}</typography-legacy>
      <typography-legacy text-xsmall-regular>{{ cardConfig.body | translate }}</typography-legacy>
      <button *ngIf="cardConfig.ctaString" class="action-card__cta-button mt-sm" (click)="emitCtaClicked()" (keyup.enter)="emitCtaClicked()" tabindex="1">
        {{ cardConfig.ctaString | translate }}
        <bw-icon-legacy [iconName]="'chevron_right'" [color]="'var(--blue-50)'" [size]="18"></bw-icon-legacy>
      </button>
    </div>
    <div
      *ngIf="!cardConfig.ctaString"
      tabindex="1"
      class="action-card__cta flex-column ml-sm action-card__img"
      [style.background-image]="'url(' + cardConfig.image + ')'"
      [style.background-position]="cardConfig.backgroundImagePosition || 'center'"
      [style.background-size]="cardConfig.backgroundSize || 'auto'"
      [style.background-color]="cardConfig.backgroundImageColor || 'unset'"
      [style.background-origin]="cardConfig.backgroundImageOrigin || 'unset'"
      [style.padding-left]="cardConfig.backgroundImagePaddingLeft || 'unset'"
    >
      <bw-icon-legacy
        *ngIf="!!cardConfig.iconButton"
        [iconName]="cardConfig.iconButton"
        [horizontalSpace]="'mr-xxs'"
        [size]="cardConfig.iconButtonSize"
        [color]="cardConfig.iconbuttonColor"
        class="pr-sm"
      ></bw-icon-legacy>
      <div *ngIf="!cardConfig.hideCta" class="action-card__cta_icon">
        <bw-icon-legacy [iconName]="'chevron_right'" [color]="'var(--blue-50)'"></bw-icon-legacy>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #label>
  <div class="flex-row action-card__label mb-xs">
    <bw-icon-legacy
      *ngIf="cardConfig.labelIcon"
      [iconName]="cardConfig.labelIcon"
      [color]="cardConfig.labelIconColor || '#757575'"
      [size]="cardConfig.labelIconSize || 16"
      [horizontalSpace]="'mr-xs'"
    ></bw-icon-legacy>
    <typography-legacy text-xsmall-regular [ngClass]="{ 'text-xsmall-semibold': cardConfig.labelBold }">{{
      cardConfig.label | translate
    }}</typography-legacy>
    <typography-legacy *ngIf="cardConfig.labelSub" text-xsmall-regular>
      @if (!cardConfig.labelSubRemoveDash) { &nbsp;- } &nbsp;{{ cardConfig.labelSub | translate }}</typography-legacy
    >
  </div>
</ng-template>
